import React from "react";
import "./BetaBadge.scss";
import OwLabel from "../OwLabel/OwLabel";

type Props = {
    title?: string;
    className?: string;
};

const BetaBadge = (props: Props) => {
    const title = props.title || "beta";

    return (<span
        className={"border border-danger text-uppercase text-monospace text-danger font-weight-bold " + props.className}
        style={{ fontSize: ".5rem", padding: ".25rem" }}>
        <OwLabel title={title} noBottomMargin={true} />
    </span>);
}

export default BetaBadge;
